import I18n from 'I18n';

/**
 * Prefixed I18n text implementation
 *
 * @param {string} keys Prefix keys
 * @returns {Function} Prefixed text implementation
 */
export default (keys => (key, ...rest) => I18n.text(`${keys}.${key}`, ...rest));